import { render } from "./App.vue?vue&type=template&id=ad522fca"
const script = {}

import "./App.vue?vue&type=style&index=0&id=ad522fca&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__